const getFormattedResponseValues = data => {
  const repairCode =
    data?.rule?.all.find(d => d.fact === 'repairCode')?.value || [];
  const model = data?.rule?.all.find(d => d.fact === 'model')?.value || [];

  return {
    id: data.id,
    client: data?.rule?.all.find(d => d.fact === 'client')?.value,
    industry: data?.rule?.all.find(d => d.fact === 'industry')?.value,
    brand: data?.rule?.all.find(d => d.fact === 'brand')?.value,
    productLine: data?.rule?.all.find(d => d.fact === 'productLine')?.value,
    model: model?.join(',') || '',
    serviceSite: data?.rule?.all.find(d => d.fact === 'serviceSite')?.value,
    serviceType: data?.rule?.all.find(d => d.fact === 'serviceType')?.value,
    repairSeverity:
      data?.rule?.all.find(d => d.fact === 'repairSeverity')?.value || [],
    repairCode: repairCode?.join(',') || '',
    effectiveDate: data?.effectiveDate,
    endDate: data?.endDate,
    laborRate: data?.rule?.event?.params?.laborRate,
    travelRate: data?.rule?.event?.params?.travelRate,
  };
};

export default getFormattedResponseValues;
